import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { keyLoading, selectLoading, selectVsics } from './store/slice'
import { getVsicThunk } from './store/thunk'

let cacheKey = null

const useGetVsic = (disableCallApi) => {
  const dispatch = useDispatch()

  const locale = useSelector((state) => state.i18n.locale)
  const loading = useSelector(selectLoading(keyLoading.VSIC))
  const vsics = useSelector(selectVsics)

  useEffect(() => {
    if (disableCallApi) return

    if (cacheKey !== locale) {
      cacheKey = locale
      dispatch(getVsicThunk())
    }
  }, [locale])

  // Don't need resetStore because use at dynamic report for macroeconomics

  return {
    loading,
    vsics,
  }
}

export default useGetVsic
